import React, { memo, useState } from "react";
import { Stack, Button, Menu, MenuItem } from "investira.react.components";

import { validators } from "investira.sdk";

import { ATIVO_MERCADO, ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";

const AtivosFilters = memo((props) => {
  const { filters, values, onChange } = props;

  const [anchorElMercado, setAnchorElMercado] = useState(null);
  const [anchorElAtivoTipo, setAnchorElAtivoTipo] = useState(null);

  const openMercado = Boolean(anchorElMercado);
  const openAtivoTipo = Boolean(anchorElAtivoTipo);

  function handleClickMercado(pEvent) {
    setAnchorElMercado(pEvent.currentTarget);
  }

  function handleCloseMercado() {
    setAnchorElMercado(null);
  }

  function handleSetMercado(pValue) {
    onChange({ mercado: pValue });
    handleCloseMercado();
  }

  function handleClickAtivoTipo(pEvent) {
    setAnchorElAtivoTipo(pEvent.currentTarget);
  }

  function handleCloseAtivoTipo() {
    setAnchorElAtivoTipo(null);
  }

  function handleSetAtivoTipo(pValue) {
    onChange({ ativo_tipo_id: pValue });
    handleCloseAtivoTipo();
  }

  function renderMercadoMenu(pMercado, pOptions = [], pCurrentValue) {
    if (validators.isEmpty(pOptions)) {
      return null;
    }

    const xMenu = pOptions
      .map((xId) => {
        const xMercado = Object.values(pMercado).filter(
          (xItem) => xItem.id === xId
        )[0];

        return {
          label: xMercado.descricao,
          value: xMercado.id,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    xMenu.unshift({ label: "Todos", value: null });

    const xCurrentLabel = xMenu.filter((xItem) => {
      return xItem.value === pCurrentValue;
    })[0];

    const xProps = {
      ...(pOptions.length >= 2
        ? { onClick: handleClickMercado }
        : { disabled: true }),
    };

    return (
      <>
        <Button variant="outlined" size="small" disableElevation {...xProps}>
          {xCurrentLabel?.label}
        </Button>
        <Menu
          anchorEl={anchorElMercado}
          open={openMercado}
          onClose={handleCloseMercado}
        >
          {xMenu.map((xItem) => {
            return (
              <MenuItem
                key={xItem.value}
                onClick={() => handleSetMercado(xItem.value)}
                sx={{ fontWeight: validators.isNull(xItem.value) ? 600 : 400 }}
              >
                {xItem.label}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }

  function renderAtivoTipoMenu(pAtivoTipo, pOptions = [], pCurrentAtivoTipo) {
    if (validators.isEmpty(pOptions)) {
      return null;
    }

    let xOptions = [];
    let xMenu = [];

    if (pOptions.length >= 1 && !validators.isNull(pOptions[0])) {
      xOptions = pOptions.map((xItem) => {
        return pAtivoTipo[xItem];
      });

      xMenu = xOptions
        .map((xTipo) => {
          return {
            label: xTipo.descricao,
            value: xTipo.id,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    }

    xMenu.unshift({ label: "Todos", value: null });

    // const xCurrentLabel = xMenu.filter((xItem) => {
    //   return xItem.value === pCurrentAtivoTipo;
    // })[0];

    const xProps = {
      ...(pOptions.length >= 2
        ? { onClick: handleClickAtivoTipo }
        : { disabled: true }),
    };

    return (
      <>
        <Button variant="outlined" size="small" disableElevation {...xProps}>
          {pAtivoTipo[pCurrentAtivoTipo]?.descricao || "Todos"}
        </Button>
        <Menu
          anchorEl={anchorElAtivoTipo}
          open={openAtivoTipo}
          onClose={handleCloseAtivoTipo}
        >
          {xMenu.map((xItem) => {
            return (
              <MenuItem
                key={xItem.label}
                onClick={() => handleSetAtivoTipo(xItem.value)}
                sx={{ fontWeight: validators.isNull(xItem.value) ? 600 : 400 }}
              >
                {xItem.label}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }

  return (
    <Stack direction="row" sx={{ gap: "8px 8px" }} flexWrap="wrap">
      {renderMercadoMenu(ATIVO_MERCADO, filters.mercados, values.mercado)}

      {renderAtivoTipoMenu(
        ATIVO_TIPO,
        filters.ativos_tipo,
        values.ativo_tipo_id
      )}
    </Stack>
  );
});

AtivosFilters.propTypes = {};

export default AtivosFilters;
